<!-- <app-intro></app-intro> -->
<app-social-media-widgets></app-social-media-widgets>
<router-outlet></router-outlet>
<footer class="app-footer">
  <a routerLink="/regulamin-rezerwacji">{{ 'footer.terms' | translate }}</a>
  <span class="app-footer__sep">·</span>
  <a routerLink="/polityka-prywatności">{{ 'footer.privacy' | translate }}</a>
</footer>
